<template>
    <section class="main">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-profile"></i>实名相关</el-breadcrumb-item>
                <el-breadcrumb-item>玩家信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='账号'>
                                <el-input
                                    v-model='queryParams.account'
                                    placeholder='请输入账号'
                                    clearable
                                    size='mini'
                                    style='width: 180px'
                                />
                            </el-form-item>
                            <el-form-item label='手机号'>
                                <el-input
                                    v-model='queryParams.phone'
                                    placeholder='请输入手机号'
                                    clearable
                                    size='mini'
                                    style='width: 180px'
                                />
                            </el-form-item>
                            <el-form-item label='userId'>
                                <el-input
                                    v-model='queryParams.userId'
                                    placeholder='请输入userId'
                                    clearable
                                    size='mini'
                                    style='width: 180px'
                                />
                            </el-form-item>
                            
                            <el-form-item label='封禁状态'>
                                <el-switch
                                    v-model='queryParams.showState'
                                    active-color='#13ce66'
                                    :active-value='1'
                                    :inactive-value='0'
                                    inactive-color='#ff4949'>
                                </el-switch>
                            </el-form-item>
                            
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='getPlayers'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>

            <el-table
                :data="table.tableData"
                v-loading="table.loading"
                :cell-style="{ textAlign: 'center' }"
                :header-cell-style="{ textAlign: 'center' }"
                >
                <el-table-column label='玩家ID' width='250' prop='userId'></el-table-column>
                <el-table-column label="账号" prop="account"></el-table-column>
                <el-table-column label="手机" prop="phone"></el-table-column>
                <el-table-column label='出生年月' prop='birthday'></el-table-column>
                <el-table-column label="状态" prop="state">
                    <template slot-scope="{ row }">
                        <el-tag v-if='row.showState === 0' type='success'>正常</el-tag>
                        <el-tag v-else type='danger'>已封禁</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label='注册时间' prop='createTime'></el-table-column>
                <el-table-column label='渠道' prop='state'>
                    <template slot-scope='{ row }'>
                        <span v-if='row.platformStr'>
                            <el-tag style='margin-right: 5px' v-for='(item, index) in row.platformStr.split(",")'
                                    :key='index'
                                    type='success'>{{ platformNameMapping[item] ? platformNameMapping[item] : item }}</el-tag>
                        </span>
                        <el-tag v-else type='success'>官服</el-tag>
                    </template>
                </el-table-column>
                
                <el-table-column label='操作' width='300px' prop='method' v-if='permission'>
                    <template slot-scope="{ row }">
                        
                        <el-button type='info' size='mini' v-if='row.phone'
                                   @click='deleteCaptchaSendLimit(row.phone, 1)'>
                            短信
                        </el-button>
                        <el-button type='primary' icon='el-icon-edit' size='mini'
                                   @click='showUpdateForm(row)'></el-button>
                        <el-button type='danger' size='mini' v-if='row.showState === 0' @click='banPlayer(row.userId)'>
                            封禁
                        </el-button>
                        <el-button type='success' size='mini' v-else @click='unsealPlayer(row.userId)'>解禁</el-button>
                        <el-button type="info" icon="el-icon-delete" size="mini" @click="showDeletePlayerForm(row.userId)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="table.pageIndex"
                    :page-size="table.pageSize"
                    :total="table.pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 修改玩家弹出框 -->
        <el-dialog
            title="更改信息"
            :visible.sync="updatePlayerForm.dialogVisible"
            width="50%"
            :close-on-click-modal="false"
            @close="updateDialogClosed()"
            >
            <el-form ref='updatePlayerForm' label-width='90px'>
                <el-form-item label="玩家ID" prop="userId">
                    <el-input v-model='userInfo.userId' disabled></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="identity">
                    <el-input v-model='userInfo.phone'></el-input>
                </el-form-item>
                <el-form-item v-if='!userInfo.idCardNumberExistStatus || userInfo.clearIdCard' label='出生日期'
                              prop='identity'>
                    <el-input placeholder='1999-07-03 形式' v-model='userInfo.birthday'></el-input>
                </el-form-item>
                <el-form-item v-if='userInfo.idCardNumberExistStatus' label='清除身份证' prop='clearIdCard'>
                    <el-switch
                        active-text='清除'
                        inactive-text='保留'
                        v-model='userInfo.clearIdCard'
                        active-color='#13ce66'
                        inactive-color='#ff4949'>
                    </el-switch>
                    <el-alert
                        title="该账号已成功使用身份证进行实名, 如果想要修改用户的出生日期, 需要勾选'清除身份证', 如果不清除身份证号, 用户出生日期将以身份证号为准"
                        style='margin-top: 1rem'
                        type='warning'>
                    </el-alert>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updatePlayerForm.dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="updatePlayer('updatePlayerForm')" :loading="updatePlayerForm.loading" :disabled="updatePlayerForm.loading">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 删除玩家弹出框 -->
        <el-dialog
            :title=deletePlayerForm.message
            :visible.sync="deletePlayerForm.dialogVisible"
            width="40%"
            :close-on-click-modal="false"
            @close="deleteDialogClosed()"
            >
            <el-form :model="deletePlayerForm" ref="deletePlayerForm" label-width="90px">
                <el-form-item label="执行人密码" prop="userId">
                    <el-input placeholder='请输入您的管理后台登录密码' type="password" v-model="deletePlayerForm.password" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deletePlayerForm.dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="deletePlayer('deletePlayerForm')" :loading="deletePlayerForm.loading" :disabled="deletePlayerForm.loading">确 定</el-button>
            </span>
            
        </el-dialog>
    </section>
</template>

<script>
import moment from 'moment';
import { localStg } from '@/utils/storage/local';
import { EnumPermission } from '@/constant/enums';
import { cottonUserApi } from '../../api/Account/userCotton';
import { deepCopy } from '@/utils/object';

export default {
    name: 'Players',
    data() {
        return {
            // 表单数据
            table: {
                tableData: [],
                pageIndex: 1,   // 页码
                pageSize: 15,    // 单页数据量
                pageTotal: 0,   // 总数据量

                loading: false // 等待动画
            },

            query: {
                account: undefined,
                idCardNumber: undefined
            },
            
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                account: undefined,
                phone: undefined,
                userId: undefined,
                showState: 0
            },
            userInfo: {},
            // 修改表单
            updatePlayerForm: {
                userId: '',
                phone: '',
                identity: '',
                birthday: '',

                loading: false, // 等待动画
                dialogVisible: false
            },

            // 删除表单
            deletePlayerForm: {
                message: '',   // 删除提示信息
                password: '',  // 管理员密码

                loading: false, // 控制等待动画
                dialogVisible: false
            },
            
            permission: false,  // 是否是超级管理员
            platformNameMapping: {
                huawei: '华为',
                taptap: 'TapTap',
                open3839: '好游快爆',
                google: 'Google',
                harmonyOS: '鸿蒙',
                apple: '苹果'
            }
        }
    },
    created() {
        this.getPlayers()
    },

    mounted() {
        // 判断是否是超级管理员, 来决定是否显示修改和删除按钮
        let roleList = localStg.get('roleList')
        if (roleList.includes(EnumPermission.superAdministratorName)) {
            this.permission = true
        } else {
            this.permission = false
        }
    },

    activated() {
        this.getPlayers()
    },
    methods: {
        resetQuery() {
            this.queryParams = {
                account: undefined,
                phone: undefined,
                userId: undefined,
                showState: 0
            };
            this.table.pageIndex = 1;
            this.getPlayers();
        },
        /**
         * 获得表格数据
         */
        getPlayers() {
            this.table.loading = true
            this.queryParams.pageNum = this.table.pageIndex;
            this.queryParams.pageSize = this.table.pageSize;
            // 发送请求
            cottonUserApi.queryUserCotton(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.table.tableData = result.data.result;
                    this.table.pageIndex = result.data.pageNum;
                    this.table.pageSize = result.data.pageSize;
                    this.table.pageTotal = result.data.total;
                }
                
                this.table.loading = false
            })
        },

        /**
         * 修改玩家信息
         * @param {*} formName
         */
        updatePlayer(formName) {
            this.updatePlayerForm.loading = true;
            
            let params = {
                birthday: this.userInfo.birthday,
                userId: this.userInfo.userId,
                clearIdCard: this.userInfo.clearIdCard,
                phone: this.userInfo.phone
            };
            // 发送请求
            cottonUserApi.updateUserCotton(params).then(res => {
                if (res.code === 200) {
                    // 清空表单数据并关闭窗口
                    this.$refs.updatePlayerForm.resetFields();
                    this.updatePlayerForm.dialogVisible = false;
                    // 提示成功并刷新表格数据
                    this.$message.success(res.message);
                    this.getPlayers();
                    
                }
                
                this.updatePlayerForm.loading = false;
            }).catch(err => {
                this.updatePlayerForm.loading = false;
            })
        },

        /**
         * 封禁玩家
         * @param userId
         */
         banPlayer(userId) {
            this.$modal.confirm('是否确认封禁"' + userId + '"用户？').then(function() {
                return cottonUserApi.updateUserCotton({ userId: userId, showState: 1 });
            }).then((result) => {
                if (result.code === 200) {
                    this.getPlayers();
                    this.$modal.msgSuccess(result.message);
                }
            }).catch(() => {
            });
        },
        deleteCaptchaSendLimit(contact, type) {
            this.$modal.confirm('是否重置"' + contact + '"账号的验证码发送次数?').then(function() {
                return cottonUserApi.deleteCaptchaSendLimit({ contact, type });
            }).then((result) => {
                if (result.code === 200) {
                    this.getPlayers();
                    this.$modal.msgSuccess(result.message);
                }
            }).catch(() => {
            });
        },

        /**
         * 解禁玩家
         * @param userId
         */
        unsealPlayer(userId) {
            this.$modal.confirm('是否确认解除用户"' + userId + '"的封禁状态？').then(function() {
                return cottonUserApi.updateUserCotton({ userId: userId, showState: 0 });
            }).then((result) => {
                if (result.code === 200) {
                    this.getPlayers();
                    this.$modal.msgSuccess(result.message);
                }
            }).catch(() => {
            });
        },

        /**
         * 物理删除玩家
         * @param userId
         */
        deletePlayer(userId) {
            this.deletePlayerForm.loading = true

            // 参数
            let params = { 'userId': this.deletePlayerForm.userId, 'password': this.deletePlayerForm.password }
            // 发送请求
            cottonUserApi.deleteUserCotton(params).then(res => {
                if (res.code === 200) {
                    this.$refs.deletePlayerForm.resetFields()
                    this.$message.success(res.message)
                    
                    this.deletePlayerForm.dialogVisible = false
                    this.getPlayers()

                } else {
                    this.$message.error(res.message)
                }

            }).finally(() => {
                this.deletePlayerForm.loading = false
            })
        },

        /**
         * 显示修改框
         */
        showUpdateForm(userInfo) {
            this.updatePlayerForm.dialogVisible = true
            this.userInfo = deepCopy(userInfo);
        },

        /**
         * 监听修改框关闭
         */
        updateDialogClosed() {
            this.userInfo = {};
            this.$refs.updatePlayerForm.resetFields()
        },

        /**
         * 显示删除框
         * @param userId
         */
        showDeletePlayerForm(userId) {
            this.deletePlayerForm.userId = userId
            this.deletePlayerForm.message = '将要删除玩家的ID: ' + userId + ''

            this.deletePlayerForm.dialogVisible = true
        },

        /**
         * 监听删除框关闭
         */
        deleteDialogClosed() {
            this.$refs.deletePlayerForm.resetFields()
        },

        /**
         *  分页导航
         */
        handlePageChange(val) {
            this.table.pageIndex = val
            this.getPlayers()
        },
        
        /**
         * 时间戳转格式
         */
        dateFormat(row, column) {
            let date = row[column.property]
            if (date == undefined) return ''
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
    }
}
</script>

<style scoped>
.handle-input {
    width: 260px;
    display: inline-block;
    margin-right: 10px;
}
</style>
